import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from '../../Box/Box';
import { Skeleton as DSSkeleton } from '../../Skeleton/Skeleton';
export const Skeleton = ({ hasLabel }) => {
    return (_jsxs(Box, { display: 'flex', gap: 'md', mt: 'xxxs', children: [_jsx(DSSkeleton, { width: 'md', height: 'md', borderRadius: 'sm' }), hasLabel && _jsx(DSSkeleton, { height: 'md', width: 'xl2' })] }));
};
